// extracted by mini-css-extract-plugin
export default {"container":"View_container__VGycS","label":"View_label__T5wFC","tooltip":"View_tooltip__Fksa+"};